module.exports = __webpack_public_path__ + "static/media/Fightext.37e81d39.png";